import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`permission`, model)
    },
    async createActivityTypePermission(model) {
        return await axios.post(`activity-type-permission`, model)
    },
    async fetchById(id) {
        return await axios.get(`permission/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`permission?q=${query}&page=${page}`)
    },
    async all() {
        return await axios.get(`permission/all`)
    },
    async allActivityTypePermission() {
        return await axios.get(`activity-type-permission/all`)
    },
    
    async update(id, model) {
        return await axios.put(`permission/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`permission/${id}`)
    },
}
